export const publicConfig = {
  app: {
    ogBaseUrl: process.env.GATSBY_OG_BASE_URL ?? '',
    unsplashAccount: '',
    url: process.env.GATSBY_SITE_URL ?? process.env.URL ?? ''
  },
  cookies: {
    scriptUrl: `https://app.secureprivacy.ai/script/${process.env.GATSBY_COOKIESANDPRIVACY}.js`
  },
  env: {
    cookiesDisabled: process.env.GATSBY_COOKIES_DISABLED === 'true',
    isDev: process.env.NODE_ENV === 'development',
    isTest: process.env.NODE_ENV === 'test'
  },
  recaptcha: {
    key: process.env.GATSBY_RECAPTCHA_KEY ?? ''
  }
}
